export default __webpack_public_path__ + "static/media/578.9aba7c15.gif";